<!-- 系统映射关系 -->
<template>
  <div class="mappingData">
    <vxe-table
      border
      resizable
      show-overflow
      :span-method="rowspanMethod"
      :data="tableData"
      size="mini"
      ref="dataMappingTable"
      auto-resize
    >
      <vxe-table-column
        field="onedataType"
        :title="$t('goods.mappingData.onedataType')"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column
        field="onedataTypeValue"
        :title="$t('goods.mappingData.onedataTypeValue')"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column
        field="mapSystemName"
        :title="$t('goods.mappingData.mapSystemName')"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column
        field="mapType"
        :title="$t('goods.mappingData.mapType')"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column
        field="mapTypeValue"
        :title="$t('goods.mappingData.mapTypeValue')"
        min-width="150"
      ></vxe-table-column>
    </vxe-table>
    <vxe-table
      border
      resizable
      show-overflow
      :data="callLogsDatalist"
      size="mini"
      ref="dataMappingTable"
      auto-resize
      v-if="isEdit"
      style="margin-top: 20px"
    >
      <vxe-table-column
        type="seq"
        :title="$t('goods.mappingData.seq')"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column
        field="gmtCreate"
        :title="$t('goods.mappingData.gmtCreate')"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column field="status" :title="$t('goods.mappingData.status')" min-width="150">
        <template v-slot="{ row }">
          {{ row.status == 0 ? $t('goods.mappingData.success') : $t('goods.mappingData.error') }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="errorReason" title="推动失败原因" min-width="150"></vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import XEUtils from 'xe-utils';
  export default {
    name: 'mappingData',
    props: ['dataMapping', 'callLogsData', 'isEdit'],
    data() {
      return {
        tableData: [],
        callLogsDatalist: [],
      };
    },
    created() {
      console.log('33333');
      console.log(this.dataMapping);
      this.tableData = JSON.parse(JSON.stringify(this.dataMapping));
      this.callLogsDatalist = JSON.parse(JSON.stringify(this.callLogsData || ''));
    },
    mounted() {},
    methods: {
      // 通用行合并函数（将相同多列数据合并为一行）
      rowspanMethod({ row, $rowIndex, column, data }) {
        const fields = ['onedataType', 'onedataTypeValue'];
        const cellValue = XEUtils.get(row, column.property);
        if (cellValue && fields.includes(column.property)) {
          const prevRow = data[$rowIndex - 1];
          let nextRow = data[$rowIndex + 1];
          if (prevRow && XEUtils.get(prevRow, column.property) === cellValue) {
            return { rowspan: 0, colspan: 0 };
          } else {
            let countRowspan = 1;
            while (nextRow && XEUtils.get(nextRow, column.property) === cellValue) {
              nextRow = data[++countRowspan + $rowIndex];
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 };
            }
          }
        }
      },
    },
  };
</script>

<style scoped></style>
